import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, steps }) => {
  const getStepStatus = (stepIndex) => {
    if (stepIndex < currentStep) return 'completed';
    if (stepIndex === currentStep) return 'current';
    return 'upcoming';
  };

  const getStepIcon = (step, status) => {
    if (status === 'completed') return 'Check';
    return step?.icon;
  };

  const getStepColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success text-success-foreground';
      case 'current':
        return 'bg-primary text-primary-foreground';
      case 'upcoming':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getConnectorColor = (stepIndex) => {
    return stepIndex < currentStep ? 'bg-success' : 'bg-muted';
  };

  return (
    <div className="w-full">
      {/* Mobile Progress Bar */}
      <div className="md:hidden mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground">
            Step {currentStep + 1} of {totalSteps}
          </span>
          <span className="text-sm text-muted-foreground">
            {Math.round(((currentStep + 1) / totalSteps) * 100)}%
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
          />
        </div>
        <div className="mt-2 text-center">
          <span className="text-sm font-medium text-foreground">
            {steps?.[currentStep]?.title}
          </span>
        </div>
      </div>
      {/* Desktop Step Indicator */}
      <div className="hidden md:block">
        <nav aria-label="Progress">
          <ol className="flex items-center justify-center space-x-8">
            {steps?.map((step, stepIndex) => {
              const status = getStepStatus(stepIndex);
              return (
                <li key={step?.id} className="flex items-center">
                  {/* Step Circle */}
                  <div className="flex items-center">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 ${getStepColor(status)}`}
                    >
                      <Icon
                        name={getStepIcon(step, status)}
                        size={20}
                      />
                    </div>
                    <div className="ml-3">
                      <div className={`text-sm font-medium ${
                        status === 'current' ? 'text-primary' :
                        status === 'completed'? 'text-success' : 'text-muted-foreground'
                      }`}>
                        {step?.title}
                      </div>
                      <div className="text-xs text-muted-foreground">
                        {step?.description}
                      </div>
                    </div>
                  </div>
                  {/* Connector Line */}
                  {stepIndex < steps?.length - 1 && (
                    <div className="ml-8 mr-8">
                      <div
                        className={`w-16 h-0.5 transition-all duration-300 ${getConnectorColor(stepIndex)}`}
                      />
                    </div>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default ProgressIndicator;